<template>
  <div>
    <Head title="Local Purchase Order" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-orange-400 hover:text-orange-600" href="/purchaseOrders">
        Local Purchase Orders
      </Link>
      <span class="text-orange-400 font-medium">/</span>{{ supplier.name }}
    </h1>
    <div class="max-w-full bg-white rounded-md shadow mb-3">
      <form @submit.prevent="store">
        <div class="pb-2 pr-6 w-full lg:w-full mb-8">
          <div class="flex flex-wrap -mb-16 -mr-6 p-8">
            <div class="pb-2 pr-6 w-full lg:w-7/12">
              <multiselect
                v-model="form.budget_line_id"
                id="budget_line_id"
                placeholder="Search Account"
                :options="budgetLines"
                :close-on-select="true"
                :searchable="true"
                :error="form.errors.budget_line_id"
                :style= "form.errors.budget_line_id ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
              />
              <div v-if="form.errors.budget_line_id" class="form-error">{{ form.errors.budget_line_id }}</div>
            </div>
            <div class="pb-2 pr-6 w-full lg:w-3/12">
              <select-input
                v-model="form.status"
                :error="form.errors.status"
                class="w-full lg:w-ful"
              >
                <option :value="null">
                  Select Status
                </option>
                <option
                  v-for="status in statuses"
                  :key="status.id"
                  :value="status.id"
                >
                  {{ status.name }}
                </option>
              </select-input>
            </div>
            <div class="pb-2 pr-6 w-full lg:w-2/12">
              <Checkbox label="VAT" :active="active" @input="vat = $event"/>
            </div>
            <div v-show ="form.status == 'Planned'" class="pb-2 pr-6 w-full lg:w-8/12">
              <text-input
                :key="pindex"
                v-model="form.planned_date" type="date" :error="form.errors.planned_date" class="w-full lg:w-ful" plceholder="Planned Date" />
            </div>
            <div class="pb-2 pr-6 w-full lg:w-2/12">
              <select-input
                v-model="form.currency_id"
                :error="form.errors.currency_id"
                class="w-full lg:w-ful"
              >
                <option :value="null">
                  Select Currency
                </option>
                <option
                  v-for="currency in currencies"
                  :key="index"
                  :value="currency.value"
                >
                  {{ currency.label }}
                </option>
              </select-input>
            </div>
          </div>
          <div
            v-for="(order, index) in form.orders"
            :key="index"
            class="flex flex-wrap -mb-16 -mr-6 p-8"
          >
            <div class="pb-2 pr-6 w-full lg:w-5/12">
              <select-input
                v-model="order.sku_id"
                class="w-full lg:w-ful"
              >
                <option :value="null">
                  Select SKU
                </option>
                <option
                  v-for="sku in skus"
                  :key="index"
                  :value="sku.sku_id"
                >
                  {{ sku.part_number }}: {{ sku.description }}
                </option>
              </select-input>
              <span
                v-if="isValidationErrors(`orders.${index}.sku_id`)"
                class="mt-3"
              >
                <span class="form-error">{{ showValidationErrors(`orders.${index}.sku_id`) }}</span>
              </span>
            </div>
            <div class="pb-2 pr-6 w-full lg:w-3/12">
              <text-input
                :key="index"
                class="w-full lg:w-full"
                v-model="order.quantity"
                :error="form.errors.quantity"
                placeholder="Quantity"
              />
              <span
                v-if="isValidationErrors(`orders.${index}.quantity`)"
                class="mt-3"
              >
                <span class="form-error">{{ showValidationErrors(`orders.${index}.quantity`) }}</span>
              </span>
            </div>
            <div class="pb-2 pr-6 w-full lg:w-1/12 hidden">
              <text-input
                :key="index"
                class="w-full lg:w-full"
                v-model="order.unit_of_measure"
                :error="form.errors.unit_of_measure"
                placeholder="Unit of Measure"
              />
              <span
                v-if="isValidationErrors(`orders.${index}.unit_of_measure`)"
                class="mt-3"
              >
                <span class="form-error">{{ showValidationErrors(`orders.${index}.unit_of_measure`) }}</span>
              </span>
            </div>
            <div class="pb-2 pr-6 w-full lg:w-2/12">
              <text-input
                :key="index"
                class="w-full lg:w-full"
                v-model="order.unit_price"
                :error="form.errors.unit_price"
                placeholder="Unit Price"
              />
              <span
                v-if="isValidationErrors(`orders.${index}.unit_price`)"
                class="mt-3"
              >
                <span class="form-error">{{ showValidationErrors(`orders.${index}.unit_price`) }}</span>
              </span>
            </div>
            <div class="pb-2 pr-6 w-full lg:w-1/12">
              <div class="w-full lg:w-1/2">
                <svg
                  v-show="form.orders.length > 1"
                  @click="removeOrder(index, form.orders)"
                  xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" style="color: red;">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div v-show="((index + 1) < skus.length)" class="w-full lg:w-1/2">
                <svg
                  v-show="index === countOrders"
                  @click="addOrder"
                  xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div
          class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100"
        >
          <loading-button :loading="form.processing" class="btn-orange" type="submit">
            Add Purchase Order
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Multiselect from '@vueform/multiselect'
import Checkbox from '@/Shared/Checkbox'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    Multiselect,
    Checkbox,
  },
  layout: Layout,
  remember: 'form',
  props: {
    supplier: Object,
    skus: Array,
    statuses: Array,
    budgetLines: {
      type: Array,
      default: () => []
    },
    active: Boolean,
    currencies: Object,
  },
  data() {
    return {
      vat: false,
      form: this.$inertia.form({
        budget_line_id: null,
        status: null,
        currency_id: null,
        planned_date: null,
        orders: [{
          sku_id: null,
          quantity: null,
          unit_price: null,
          unit_of_measure: null,
        }],
      }),
      measure: { unit: null, index: null },
    }
  },
  computed: {
    countOrders() {
      if (this.form.orders.length === 0) {
        return 0;
      }
      return this.form.orders.length - 1;
    },
  },
  methods: {
    addOrder(e) {
      e.preventDefault();
      this.form.orders.push({
        sku_id: null,
        quantity: null,
        unit_price: null,
        unit_of_measure: null,
      });
    },
    isValidationErrors(value) {
      if (this.form.errors) {
        const error = this.form.errors[value] || '';
        return !!error;
      }
      return false;
    },
    showValidationErrors(value) {
      if (this.form.errors) {
        const error = this.form.errors[value] || '';
        return error || '';
      }
      return '';
    },
    removeOrder(index, orders) {
      orders.splice(index, 1)
    },
    getUnitOfMeasure(index, order) {
      this.measure.unit = order.unit_of_measure
      this.measure.index = index
    },
    store() {
      this.form.transform(({...data }) => ({
        has_vat: this.vat,
        ...data,
      }));
      this.form.post(`/suppliers/${this.supplier.id}/purchaseOrders`, {
        onSuccess: () => {
          this.form.reset(
            'sku_id',
            'currency_id',
            'vat',
            'has_vat',
            'budget_line_id',
            'status',
            'planned_date',
            'quality',
            'unit_price',
            'unit_of_measure'
          )
        }
      })
    },
  },
}
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style type="text/css">
  .multiselect-option.is-selected.is-pointed {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
  .multiselect-option.is-selected {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
</style>